import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useAuthContext from '../../apps/common/modules/auth/hooks/useAuthContext';
import { SideNavItems } from '../../utils/constants/RoleConstants';
import { INavItemDetail } from '../../utils/Interface/NavInterface';
import Constants from '../../utils/Constants';

const SideNavFM = () => {
    const { isAuthenticated, getUsersRoles } = useAuthContext();
    const usersRoles = getUsersRoles();

    const getNavItem = (navItemDetail: INavItemDetail) => {
        const navItemRoles = navItemDetail.roles;
        for (let roleIndex = 0; roleIndex < navItemRoles.length; roleIndex++) {
            if (usersRoles.includes(navItemRoles[roleIndex])) {
                return navItem(navItemDetail, roleIndex);
            }
        }
        return null;
    };

    const navItem = (navItemDetail: INavItemDetail, roleIndex: number) => {
        return (
            <Link key={roleIndex} to={navItemDetail.redirectUrl}>
                <li>{navItemDetail.label}</li>
            </Link>
        );
    };

    return (
        <>
            {isAuthenticated() && (
                <Accordion className="accordion">
                    {SideNavItems.feedlotManagerSideNavItem?.subFMItemsPrimary?.map(
                        (item, index) => {
                            let component: JSX.Element | null = null;
                            for (let i = 0; i < item.parentRoles.length; i++) {
                                if (usersRoles.includes(item.parentRoles[i])) {
                                    component = (
                                        <Accordion.Item
                                            className="accordion-item"
                                            key={index}
                                            eventKey="-1"
                                        >
                                            <Link to={item.redirectUrl}>
                                                <Accordion.Header className="accordion-header">
                                                    {item.icon}
                                                    {item.accordionName}
                                                </Accordion.Header>
                                            </Link>
                                        </Accordion.Item>
                                    );
                                    break;
                                }
                            }
                            return component;
                        },
                    )}
                    {SideNavItems.feedlotManagerSideNavItem?.subFMItemsSecondary?.map(
                        (item, index) => {
                            let component: JSX.Element | null = null;
                            for (let i = 0; i < item.parentRoles.length; i++) {
                                if (usersRoles.includes(item.parentRoles[i])) {
                                    component = (
                                        <Accordion.Item
                                            className="accordion-item"
                                            key={index}
                                            eventKey={index.toString()}
                                        >
                                            <Accordion.Header
                                                key={index}
                                                className="accordion-header"
                                            >
                                                {item.icon}
                                                {item.accordionName}
                                            </Accordion.Header>
                                            <Accordion.Body className="accordion-body">
                                                {item.subSideNavItems
                                                    ?.filter(
                                                        (
                                                            sideNavItemDetail: INavItemDetail,
                                                        ) =>
                                                            !sideNavItemDetail.authType ||
                                                            sideNavItemDetail.authType ===
                                                                localStorage.getItem(
                                                                    Constants
                                                                        .StorageItems
                                                                        .AUTH_TYPE,
                                                                ),
                                                    )
                                                    .map(
                                                        (
                                                            sideNavItemDetail: INavItemDetail,
                                                            subIndex: number,
                                                        ) => {
                                                            return sideNavItemDetail.isDisabled ? null : (
                                                                <Accordion.Item
                                                                    className="accordion-subitem"
                                                                    key={
                                                                        subIndex
                                                                    }
                                                                    eventKey={subIndex.toString()}
                                                                >
                                                                    {getNavItem(
                                                                        sideNavItemDetail,
                                                                    )}
                                                                </Accordion.Item>
                                                            );
                                                        },
                                                    )}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                    break;
                                }
                            }
                            return component;
                        },
                    )}
                </Accordion>
            )}
        </>
    );
};

export default SideNavFM;
